import{useState,useEffect}from'react'

export default function Subscribe(){
const[loading,setLoading]=useState(null)

useEffect(()=>{
if(window.location.search.includes('subscribed=true')||window.location.search.includes('cancelled=true')){
window.history.replaceState({},'',window.location.pathname)
}
},[])

async function handleSubscribe(priceId){
setLoading(priceId)
try{
const response=await fetch('/api/create-checkout-session',{
method:'POST',
headers:{'Content-Type':'application/json'},
body:JSON.stringify({priceId})
})
const{url}=await response.json()
window.location.href=url
}catch(err){
console.error(err)
setLoading(null)
}}

const PRO_PRICE='price_1TIVqpRkCQRUPyKxtdJA1HkF'
const TEAM_PRICE='price_1TIzylRkCQRUPyKxiZWfFsxy'

const plans=[
{
name:'Free',
price:'$0',
period:'forever',
features:['Up to 2 events/month','Basic P&L','1 user'],
cta:'Current Plan',
priceId:null,
disabled:true
},
{
name:'Pro',
price:'$49',
period:'month',
features:['Unlimited events','Full P&L projections','Contract generation + PDF','Settlement flow + PDF','AI email parser','Up to 3 users'],
cta:'Start Free Trial',
priceId:PRO_PRICE,
disabled:false,
featured:true
},
{
name:'Team',
price:'$99',
period:'month',
features:['Everything in Pro','Up to 10 users','Priority support','Season reporting'],
cta:'Start Free Trial',
priceId:TEAM_PRICE,
disabled:false,
featured:false
}
]

return(
<div style={{padding:'2rem 0'}}>
<h2 style={{fontSize:'18px',fontWeight:'600',marginBottom:'4px',textAlign:'center'}}>Choose Your Plan</h2>
<p style={{fontSize:'13px',color:'#888',textAlign:'center',marginBottom:'1.5rem'}}>Upgrade anytime. Cancel anytime.</p>
<div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'12px'}}>
{plans.map((plan,i)=>(
<div key={i} style={{background:'white',border:plan.featured?'2px solid #1a6b4a':'1px solid #eee',borderRadius:'12px',padding:'1.25rem',position:'relative'}}>
{plan.featured&&<div style={{position:'absolute',top:'-12px',left:'50%',transform:'translateX(-50%)',background:'#1a6b4a',color:'white',fontSize:'11px',padding:'3px 12px',borderRadius:'20px',fontWeight:'500'}}>Most Popular</div>}
<h3 style={{fontSize:'16px',fontWeight:'600',marginBottom:'4px'}}>{plan.name}</h3>
<div style={{marginBottom:'1rem'}}>
<span style={{fontSize:'28px',fontWeight:'600',color:'#1a6b4a'}}>{plan.price}</span>
<span style={{fontSize:'13px',color:'#888'}}>/{plan.period}</span>
</div>
<ul style={{listStyle:'none',marginBottom:'1.25rem'}}>
{plan.features.map((f,j)=>(
<li key={j} style={{fontSize:'13px',color:'#555',padding:'3px 0',display:'flex',alignItems:'center',gap:'6px'}}>
<span style={{color:'#1a6b4a',fontWeight:'600'}}>✓</span>{f}
</li>
))}
</ul>
<button
onClick={()=>!plan.disabled&&handleSubscribe(plan.priceId)}
disabled={plan.disabled||loading!==null}
style={{
width:'100%',
padding:'10px',
background:'#1a6b4a',
color:'white',
border:'none',
opacity:plan.disabled?0.5:1,
border:'none',
borderRadius:'8px',
fontSize:'14px',
fontWeight:'500',
cursor:plan.disabled?'default':'pointer'
}}>
{loading===plan.priceId?'Redirecting...':plan.cta}
</button>
</div>
))}
</div>
</div>
)}